import type { GPUInstanceType } from "types/InstanceTypes";
import { formatMemoryForDisplay } from "components/Environment/Create/utils";
import { formatGpuName } from "utils/gpuNames";

export const getComputeHardwareSummary = (
  instanceType: GPUInstanceType | null,
): string[] => {
  if (!instanceType) {
    return ["Selecting instance"];
  }

  const gpu = instanceType.supported_gpus?.[0];
  if (gpu) {
    return [
      `${gpu.count || 1}× ${formatGpuName(gpu.name)}`,
      `${formatMemoryForDisplay(gpu.memory)} VRAM`,
    ];
  }

  const cpuLabel = instanceType.vcpu === 1 ? "CPU" : "CPUs";
  return [
    `${instanceType.vcpu} ${cpuLabel}`,
    `${formatMemoryForDisplay(instanceType.memory)} RAM`,
  ];
};
